'use strict';

// utility class
import ApplyClass from '../Utils/ApplyClass';
import Common from '../Utils/Common';
import Basic from '../Controller/Basic';

import HeaderDate from '../View/Basic/HeaderDate';
import AgreeCookie from '../View/Basic/AgreeCookie';
import SmoothScroll from '../View/Basic/SmoothScroll';
import LongProcess from '../View/Basic/LongProcess';
import SetStepperHeight from '../View/Basic/SetStepperHeight';
import TableSort from '../View/Basic/TableSort';
import Pagination from '../View/Basic/Pagination';
import TableSearch from '../View/Basic/TableSearch';
import TableFilter from '../View/Basic/TableFilter';
import UpperScrollbar from '../View/Basic/UpperScrollbar';
import ClearSearchCondition from '../View/Basic/ClearSearchCondition';

import ExemptionModal from '../View/Basic/ExemptionModal';
import ErrorModal from '../View/Basic/ErrorModal';
import WarningModal from '../View/Basic/WarningModal';
import OutputAccidentsListExcel from '../View/Basic/OutputAccidentsListExcel';
import ApplyModal from '../View/Basic/ApplyModal';
import ChangeLevelModal from '../View/Basic/ChangeLevelModal';
import SaveFilter from '../View/Basic/SaveFilter';
import BtnDeleteFilter from '../View/Basic/BtnDeleteFilter';
import GetSavedFiltersListener from '../View/Basic/GetSavedFiltersListener';
import ActivateBootstrapModal from '../View/Basic/ActivateBootstrapModal';
import TableSetStickyColumns from '../View/Basic/TableSetStickyColumns';
import TableTracking from '../View/Basic/TableTracking';
import AdditionalTitleDelete from '../View/Basic/AdditionalTitleDelete';
import AgreePolicy from '../View/Basic/AgreePolicy';
import AgreeSupporterPolicy from '../View/Basic/AgreeSupporterPolicy';

import DisabledTrigger from '../View/Basic/DisabledTrigger';
import BtnSendMail from '../View/Basic/BtnSendMail';

import MailDuplicationModal from '../View/Basic/MailDuplicationModal';
import WarningContinuationModal from '../View/Basic/WarningContinuationModal';
import ChangeLeaderTrainingType from '../View/Basic/ChangeLeaderTrainingType';
import OperatorDetailModal from '../View/Basic/OperatorDetailModal';
import HistoryFilter from '../View/Basic/HistoryFilter';
import ResetFilter from '../View/Basic/ResetFilter';
import ShowInfo from '../View/Basic/ShowInfo';
import BeforeUnload from '../View/Basic/BeforeUnload';
import SavedApplyFilter from '../View/Basic/SavedApplyFilter';
import TrackingPopup from '../View/Basic/TrackingPopup';

$(() => {
	const BasicController = new Basic();
	// デバイス、ブラウザ判定
	Common.addHtmlClass();
	objectFitImages();
	//スムーススクロール
	$('a[href^="#"]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SmoothScroll, $e, [$e, BasicController]);
	});
	// Cookie同意
	$('body').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AgreeCookie, $e, [$e, BasicController]);
	});
	// 規約同意
	$('input#agree').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AgreePolicy, $e, [$e, BasicController]);
	});
	// 規約同意
	$('input#agree-policy').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AgreeSupporterPolicy, $e, [$e, BasicController]);
	});
	// 長い処理時のローディング表示
	$('.long-process').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(LongProcess, $e, [$e, BasicController]);
	});
	// stepperの高さ設定
	$('.stepper').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetStepperHeight, $e, [$e, BasicController]);
	});
	// テーブルソート
	$('.table-sort').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TableSort, $e, [$e, BasicController]);
	});
	// テーブル絞り込み
	$('.table-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TableFilter, $e, [$e, BasicController]);
	});
	// ページネーション
	$('.page-link').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Pagination, $e, [$e, BasicController]);
	});
	// テーブル検索
	$('.btn-table-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TableSearch, $e, [$e, BasicController]);
	});
	// 検索条件クリア
	$('.anchor-clear-search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ClearSearchCondition, $e, [$e, BasicController]);
	});
	$('#now-date').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HeaderDate, $e, [$e, BasicController]);
	});
	$('.btn-exemption').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ExemptionModal, $e, [$e, BasicController]);
	});
	$('.btn-output-accidents-list-excel').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(OutputAccidentsListExcel, $e, [$e, BasicController]);
	});
	// 確認画面でのエラーモーダル
	$('#has-error').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ErrorModal, $e, [$e, BasicController]);
	});
	// 確認画面でのエラーモーダル
	$('#has-warning').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(WarningModal, $e, [$e, BasicController]);
	});
	// 確認画面でのエラーモーダル
	$('#has-continuation-warning').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(WarningContinuationModal, $e, [$e, BasicController]);
	});
	// 権限切り替えモーダル
	$('#modal-change-level').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeLevelModal, $e, [$e, BasicController]);
	});
	// 確認画面でのエラーモーダル
	$('.btn-apply-action').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ApplyModal, $e, [$e, BasicController]);
	});
	$('#modal-saved-filters').each((idx, e) => {
		new ActivateBootstrapModal(); // Bootstrapモーダルをアクティベーション
		new GetSavedFiltersListener(BasicController); // 保存済検索条件リストの取得完了を監視
	})
	// 検索条件保存
	$('.btn-input-filter-name').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SaveFilter, $e, [$e, BasicController]);
	});
	// 検索条件削除
	$('.btn-delete-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnDeleteFilter, $e, [$e, BasicController]);
	});
	// 横スクロールする table の sticky で固定する列をセットする
	$('.table-set-sticky-columns').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TableSetStickyColumns, $e, [$e, BasicController]);
	});
	// 追跡者テーブル
	$('#table-tracking').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TableTracking, $e, [$e, BasicController]);
	});
	// 従登録削除
	$('.additional-title-delete').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AdditionalTitleDelete, $e, [$e, BasicController]);
	});
	// DisabledTrigger
	$('.disabled_trigger').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DisabledTrigger, $e, [$e, BasicController]);
	});
	// メールテスト送信
	$('.btn-send-mail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnSendMail, $e, [$e, BasicController]);
	});
	// OB・OGメール重複モーダル
	$('#mail-duplication-modal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MailDuplicationModal, $e, [$e, BasicController]);
	});
	// 指導者訓練歴切り替え
	$('#leader-training-type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeLeaderTrainingType, $e, [$e, BasicController]);
	});
	// 操作担当者情報モーダル表示
	$('.operator-detail-modal-link').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(OperatorDetailModal, $e, [$e, BasicController]);
	});
	// 変更履歴絞り込み
	$('#history-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HistoryFilter, $e, [$e, BasicController]);
	});
	// 変更履歴絞り込み解除
	$('#reset-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ResetFilter, $e, [$e, BasicController]);
	});
	// 申請・承認情報表示
	$('#show-info').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShowInfo, $e, [$e, BasicController]);
	});
	// 申請・承認情報表示
	$('.table-scrollbar').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(UpperScrollbar, $e, [$e, BasicController]);
	});
	// 離脱メッセージ
	$('#btn-reset-beforeunload').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BeforeUnload, $e, [$e, BasicController]);
	});
	// 絞り込み保存
	$('#saved-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SavedApplyFilter, $e, [$e, BasicController]);
	});
	// 追跡者詳細ポップアップ
	$('.block-tracking-detail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TrackingPopup, $e, [$e, BasicController]);
	});
});


//object-fit polyfill
/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = (function () {
	'use strict';

	var OFI = 'bfred-it:object-fit-images';
	var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
	var testImg = typeof Image === 'undefined' ? { style: { 'object-position': 1 } } : new Image();
	var supportsObjectFit = 'object-fit' in testImg.style;
	var supportsObjectPosition = 'object-position' in testImg.style;
	var supportsOFI = 'background-size' in testImg.style;
	var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
	var nativeGetAttribute = testImg.getAttribute;
	var nativeSetAttribute = testImg.setAttribute;
	var autoModeEnabled = false;

	function createPlaceholder(w, h) {
		return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
	}

	function polyfillCurrentSrc(el) {
		if (el.srcset && !supportsCurrentSrc && window.picturefill) {
			var pf = window.picturefill._;
			// parse srcset with picturefill where currentSrc isn't available
			if (!el[pf.ns] || !el[pf.ns].evaled) {
				// force synchronous srcset parsing
				pf.fillImg(el, { reselect: true });
			}

			if (!el[pf.ns].curSrc) {
				// force picturefill to parse srcset
				el[pf.ns].supported = false;
				pf.fillImg(el, { reselect: true });
			}

			// retrieve parsed currentSrc, if any
			el.currentSrc = el[pf.ns].curSrc || el.src;
		}
	}

	function getStyle(el) {
		var style = getComputedStyle(el).fontFamily;
		var parsed;
		var props = {};
		while ((parsed = propRegex.exec(style)) !== null) {
			props[parsed[1]] = parsed[2];
		}
		return props;
	}

	function setPlaceholder(img, width, height) {
		// Default: fill width, no height
		var placeholder = createPlaceholder(width || 1, height || 0);

		// Only set placeholder if it's different
		if (nativeGetAttribute.call(img, 'src') !== placeholder) {
			nativeSetAttribute.call(img, 'src', placeholder);
		}
	}

	function onImageReady(img, callback) {
		// naturalWidth is only available when the image headers are loaded,
		// this loop will poll it every 100ms.
		if (img.naturalWidth) {
			callback(img);
		} else {
			setTimeout(onImageReady, 100, img, callback);
		}
	}

	function fixOne(el) {
		var style = getStyle(el);
		var ofi = el[OFI];
		style['object-fit'] = style['object-fit'] || 'fill'; // default value

		// Avoid running where unnecessary, unless OFI had already done its deed
		if (!ofi.img) {
			// fill is the default behavior so no action is necessary
			if (style['object-fit'] === 'fill') {
				return;
			}

			// Where object-fit is supported and object-position isn't (Safari < 10)
			if (
				!ofi.skipTest && // unless user wants to apply regardless of browser support
				supportsObjectFit && // if browser already supports object-fit
				!style['object-position'] // unless object-position is used
			) {
				return;
			}
		}

		// keep a clone in memory while resetting the original to a blank
		if (!ofi.img) {
			ofi.img = new Image(el.width, el.height);
			ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
			ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

			// preserve for any future cloneNode calls
			// https://github.com/bfred-it/object-fit-images/issues/53
			nativeSetAttribute.call(el, "data-ofi-src", el.src);
			if (el.srcset) {
				nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
			}

			setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

			// remove srcset because it overrides src
			if (el.srcset) {
				el.srcset = '';
			}
			try {
				keepSrcUsable(el);
			} catch (err) {
				if (window.console) {
					console.warn('https://bit.ly/ofi-old-browser');
				}
			}
		}

		polyfillCurrentSrc(ofi.img);

		el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
		el.style.backgroundPosition = style['object-position'] || 'center';
		el.style.backgroundRepeat = 'no-repeat';
		el.style.backgroundOrigin = 'content-box';

		if (/scale-down/.test(style['object-fit'])) {
			onImageReady(ofi.img, function () {
				if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
					el.style.backgroundSize = 'contain';
				} else {
					el.style.backgroundSize = 'auto';
				}
			});
		} else {
			el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
		}

		onImageReady(ofi.img, function (img) {
			setPlaceholder(el, img.naturalWidth, img.naturalHeight);
		});
	}

	function keepSrcUsable(el) {
		var descriptors = {
			get: function get(prop) {
				return el[OFI].img[prop ? prop : 'src'];
			},
			set: function set(value, prop) {
				el[OFI].img[prop ? prop : 'src'] = value;
				nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
				fixOne(el);
				return value;
			}
		};
		Object.defineProperty(el, 'src', descriptors);
		Object.defineProperty(el, 'currentSrc', {
			get: function () { return descriptors.get('currentSrc'); }
		});
		Object.defineProperty(el, 'srcset', {
			get: function () { return descriptors.get('srcset'); },
			set: function (ss) { return descriptors.set(ss, 'srcset'); }
		});
	}

	function hijackAttributes() {
		function getOfiImageMaybe(el, name) {
			return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
		}
		if (!supportsObjectPosition) {
			HTMLImageElement.prototype.getAttribute = function (name) {
				return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
			};

			HTMLImageElement.prototype.setAttribute = function (name, value) {
				return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
			};
		}
	}

	function fix(imgs, opts) {
		var startAutoMode = !autoModeEnabled && !imgs;
		opts = opts || {};
		imgs = imgs || 'img';

		if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
			return false;
		}

		// use imgs as a selector or just select all images
		if (imgs === 'img') {
			imgs = document.getElementsByTagName('img');
		} else if (typeof imgs === 'string') {
			imgs = document.querySelectorAll(imgs);
		} else if (!('length' in imgs)) {
			imgs = [imgs];
		}

		// apply fix to all
		for (var i = 0; i < imgs.length; i++) {
			imgs[i][OFI] = imgs[i][OFI] || {
				skipTest: opts.skipTest
			};
			fixOne(imgs[i]);
		}

		if (startAutoMode) {
			document.body.addEventListener('load', function (e) {
				if (e.target.tagName === 'IMG') {
					fix(e.target, {
						skipTest: opts.skipTest
					});
				}
			}, true);
			autoModeEnabled = true;
			imgs = 'img'; // reset to a generic selector for watchMQ
		}

		// if requested, watch media queries for object-fit change
		if (opts.watchMQ) {
			window.addEventListener('resize', fix.bind(null, imgs, {
				skipTest: opts.skipTest
			}));
		}
	}

	fix.supportsObjectFit = supportsObjectFit;
	fix.supportsObjectPosition = supportsObjectPosition;

	hijackAttributes();

	return fix;

}());

// array includes polyfill
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function (searchElement, fromIndex) {

			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);
			var len = o.length >>> 0;

			if (len === 0) {
				return false;
			}

			var n = fromIndex | 0;
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			while (k < len) {
				if (o[k] === searchElement) {
					return true;
				}
				k++;
			}

			return false;
		}
	});
}
